import { useSelector } from 'react-redux';

import { getPermissions } from '@/redux/permissions/selectors';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

export const useReportPermissions = () => {
  const canRead = useSelector((state: RootState) => getPermissions(state, 'reports', actions.READ));
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'reports', actions.WRITE)
  );
  const canDelete = useSelector((state: RootState) =>
    getPermissions(state, 'reports', actions.DELETE)
  );
  return { canRead, canWrite, canDelete };
};
